import { Resource } from './resource';
import { User } from './user';
import { JobCategory } from './jobCategory';
import { JobRole } from './jobRole';
import { Status } from './status';
import { Priority } from './Priority';
import { Technology } from './technology';
import { JobDescription } from './jobDescription';
import { JobRecruiter } from './jobRecruiter';

export class JobData extends Resource {
  jobId: String;
  roleId: String;
  roleName: String;
  jobStatusId: String;
  jobStatusName: String;
  jobPriortyId: String;
  jobPriortyName: String;
  technologyId: String;
  technologyName: String;
  jobDescriptionName: String;
  jobDescriptionId: String;
  noOfVacancies: any;
  openJobCount: any;
  closedJobCount: any;
  pendingJobCount: any
  
}
